import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'notifications_config/components/list/NotificationsConfigActions';

const NotificationsConfigListRow = ({
  notificationConfig,
  company,
  subcompany,
  permissions,
  t,
  handleToggle,
}) => {
  return (
    <tr>
      {/* <td>{notificationConfig.key}</td> */}
      <td>{notificationConfig.name}</td>
      <td>{notificationConfig.send_email ? 'Si' : 'No'}</td>
      <td>{notificationConfig._usersToNotify.length}</td>
      <td>{notificationConfig.elements.length}</td>
      <td className="text-center">{t(notificationConfig.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          notificationConfig={notificationConfig}
          company={company}
          subcompany={subcompany}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(NotificationsConfigListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/list/NotificationsConfigListRow.js